// src/lib/guards/requireAuth.ts
import { redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/stores/authStore';
import { type User } from '@/types/auth';

export interface GuardContext {
  location: { pathname: string };
}

/**
 * TanStack Router beforeLoad guard: require authenticated user.
 * Redirects to /login with the attempted path preserved as ?redirect=.
 * Returns { user } on success for downstream guards to consume.
 */
export function requireAuth(ctx: GuardContext): { user: User } {
  const { user, isAuthenticated } = useAuthStore.getState();
  if (!isAuthenticated || !user) {
    // Admin routes (including /login with `redirect` search param) register in
    // Phase 3 — the `redirect` search param isn't in the current route tree's
    // schema yet, hence the `as never` cast below.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/login',
      search: { redirect: ctx.location.pathname } as never,
    });
  }
  return { user };
}
